<template>
  <div class="shadow"></div>
</template>

<script>
export default {
  name: 'Shadow'
}
</script>

<style scoped>

</style>
